import {EnvFaqDomain} from "../../domain/env/EnvFaqDomain"
import {EnvFaqId} from "../../id/env/EnvFaqId"
import {UserId} from "../../id/user/UserId"
import {ValueObject} from "ts-protocol-extension"

/**
 * 자주 묻는 질문
 */
export class EnvFaqValueObject implements ValueObject, EnvFaqDomain {
    /**
     * 기본키
     */
    id: EnvFaqId
    /**
     * 생성자 ID
     */
    creatorId: UserId
    /**
     * 제목
     */
    title: string
    /**
     * 표시 순서
     */
    displayOrder: number
    /**
     * 하위 항목 수
     */
    envFaqItemCount: number
    /**
     * 생성일
     */
    createdAt: Date
    /**
     * 마지막 수정일
     */
    lastModifiedAt?: Date
    /**
     * 삭제일
     */
    concealedAt?: Date

    constructor(o: Record<keyof EnvFaqDomain, any>) {
        this.id = BigInt(o.id)
        this.creatorId = BigInt(o.creatorId)
        this.title = String(o.title)
        this.displayOrder = Number(o.displayOrder)
        this.envFaqItemCount = Number(o.envFaqItemCount)
        this.createdAt = new Date(o.createdAt)
        if (o.lastModifiedAt !== undefined && o.lastModifiedAt !== null) {
            this.lastModifiedAt = new Date(o.lastModifiedAt)
        }
        if (o.concealedAt !== undefined && o.concealedAt !== null) {
            this.concealedAt = new Date(o.concealedAt)
        }
    }
}
